
          import $$Component from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/Register.vue?vue&type=script"
          
          import "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/Register.vue?vue&type=style"
          
          import { render } from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/Register.vue?vue&type=template"
          export * from "/home/runner/work/wp-tm-snc168/wp-tm-snc168/typescript/popup/Register.vue?vue&type=template"
          $$Component.render = render
          export default $$Component